import React from "react"

import { ActivityIndicator, View } from "react-native"

export default function() {
    return (
        <View style={{ flex: 1, height: "100%", width: "100%", alignItems: "center", justifyContent: "center" }}>
            <ActivityIndicator size={50}/>
        </View>
    )
}